import {AbstractController} from "../../../controllers/AbstractController";
import {IT_EXTRA_INFO_CONTENTS, IT_TITLE, IViewTitleController, MK_VIEW_TITLE} from "./IViewTitleController";
import {ControllerEventBus} from "../../../event-buses/controller.event-bus";
import {inject, Injectable, signal} from "@angular/core";
import {ControllerEventName} from "../../../event-buses/ControllerEventName";
import {ControllerEvent} from "../../../event-buses/ControllerEvent";
import {Helper} from "../../../helpers/Helper";

@Injectable()
export class ViewTitleController extends AbstractController implements IViewTitleController {

  constructor(controllerEventBus: ControllerEventBus) {
    super(controllerEventBus);

    const title = inject(IT_TITLE, { optional: true });
    const extraInfoContents = inject(IT_EXTRA_INFO_CONTENTS, { optional: true });

    this.addModel(MK_VIEW_TITLE, {
      title$: signal(this.injectTranslation(title) || 'No title provided'),
      enableExtraInfo$: signal(!!extraInfoContents),
      extraInfoContents$: signal(extraInfoContents ?? ''),
    });

    this.subscribe(ControllerEventName.UpdateTitle, (event) => {
      this.onUpdateTitle(event);
    });
  }

  onUpdateTitle(event: ControllerEvent): void {
    const title: string = event.eventData['title'];

    if(Helper.isValid(title)) {
      this.getModel(MK_VIEW_TITLE).title$.set(title);
    }
  }

  protected injectTranslation(title: string|null): string|null {
    if(!title) {
      return null;
    }
    else {
      let start = title.indexOf('{');
      let iteration = 0;

      while(start > -1 && iteration < 5) {
        const end = title.indexOf('}');

        if(end === -1) {
          // Invalid scenario
          break;
        }

        const token = title.substring(start, end + 1);
        const tToken = token.substring(1, token.length - 1);
        const translation = this.translate(tToken);

        title = title.replace(token, translation);

        start = title.indexOf('{');

        iteration += 1;
      }

      return title;
    }
  }
}
